export default __webpack_public_path__ + "static/media/bazzle_bg.45cbb249.jpg";